import { average, mappedArray } from '@10000/common'
import { environment } from '@10000/react'

export const assetUrl = (asset, basePath = 'shivoo') => `${environment.assetUrl}${basePath}/${asset}`
export const query = () => Object.fromEntries(new URLSearchParams(window.location.search).entries())
export const padZero = source => {
  const padded = '0' + source
  return padded.substring(padded.length - 2)
}

export const practiceAverages = answers => mappedArray(6, i => average([answers[i * 2], answers[i * 2 + 1]].filter(x => typeof x === 'number' && !isNaN(x))))
export const practiceConsensusStats = (consensus, practice) => ({
  touches: (consensus?.[practice * 2]?.touches || 0) + (consensus?.[practice * 2 + 1]?.touches || 0),
  timeTaken: (consensus?.[practice * 2]?.timeTaken || 0) + (consensus?.[practice * 2 + 1]?.timeTaken || 0)
})

export const backgroundColors = ['yellow', 'blue', 'red', 'white', 'grey']

export const cardRotations = [-2.25, 2.5]

export function getElementDimensions(element) {
  if(!element) {
    return {}
  }

  const { top, left, width, height } = element?.getBoundingClientRect?.() || {}
  const { borderRadius, boxShadow, outlineWidth, borderWidth, rotate } = window.getComputedStyle(element)
  const radius = parseInt(borderRadius) || 0
  const outline = (boxShadow ? 0 : parseInt(outlineWidth)) || 0 // box shadows cause getComputedStyle to return a value for outlineWidth - messes with size calculations
  const border = parseInt(borderWidth) || 0

  return { left, top, width, height, radius, outline, border, rotate }
}

export const randomiseLetters = content => Array.from(content)
  .map(x => {
    if(x.charCodeAt(0) >= 65 && x.charCodeAt(0) <= 90) {
      return String.fromCharCode(65 + Math.random() * 26)
    } else if (x.charCodeAt(0) >= 97 && x.charCodeAt(0) <= 122) {
      return String.fromCharCode(97 + Math.random() * 26)
    }
    return x
  })
  .join('')